import { Box, Typography } from '@mui/material';
import type { ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { Button as GenericButton } from '../Button/Button';

const Button = styled((props: ButtonProps) => {
  return (
    <GenericButton
      sx={{
        ...props.sx,
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
      variant="text"
      {...props}
    />
  );
})(() => ({}));

interface Props {
  icon: ReactNode;
  title: string;
  description: string;
  additionalText?: ReactNode;
  onAddClick?: () => void;
}

export function NoItemsPlaceholder({
  icon,
  title,
  description,
  additionalText,
  onAddClick,
}: Props) {
  const isReadonly = !onAddClick;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        p: 2,
      }}
      component={isReadonly ? 'div' : Button}
      onClick={onAddClick}
    >
      {icon}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <Typography
          sx={{ fontWeight: 500, fontSize: '1.125rem', color: '#202430' }}
        >
          {title}
        </Typography>
        <Typography color="secondary" sx={{ fontSize: '0.875rem' }}>
          {description}
        </Typography>
        {additionalText && (
          <Typography
            color={isReadonly ? 'secondary' : 'primary'}
            sx={{
              fontSize: '0.875rem',
              ...(!isReadonly && { fontWeight: 500 }),
            }}
          >
            {additionalText}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
